<template>
  <div class="networkErrorView">
    <navBar></navBar>
    <div class="content mt10 mb10 dfcjc">
      <div>
        <img src="../assets/img/nullnetwork.jpg" alt="" />
        <el-button type="primary" @click="goBack">返回首页</el-button>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import navBar from "./nav/nav.vue";
import footerBar from "./footer/footer";

export default {
  components: { navBar, footerBar },
  props: [],
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    alidate() {
      let allowed = ["reviews", "tutorials", "news"];
      console.log(allowed.includes("turtle"));
      return allowed.includes("turtle");
    },
    goBack() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.networkErrorView {
  .content {
    width: 1360px;
    height: 757px;
    margin: 10px auto;
    background: #fff;
    > div {
      width: 544px;
      text-align: center;
      margin-top: -120px;
    }
  }
  .curr {
    color: #333;
  }
}
</style>
<style lang="scss">
.networkErrorView {
  .whiteNav .navBar .center .curr {
    color: #333;
  }
}
</style>
